module.exports = "/images/milano-10.jpg";